/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from '@dnd-kit/core';
import { SortableContext, arrayMove, rectSortingStrategy } from '@dnd-kit/sortable';
import ClubBox from './ClubBox';
import SortableGridItem from '../Amenities/SortableGridItem';
import ajax from '../../../utils/ajaxHelper';
import useCommunityList from '../../../hooks/useCommunityList';

const ClubGrid = ({
  filteredAmenities,
  isAccessible,
  publicView,
  amenities,
  setCommunityDetails,
}) => {
  const { sortAmenities } = useCommunityList();
  const [items, setItems] = useState([]);
  const [activeId, setActiveId] = useState(null);
  useEffect(() => {
    setItems(sortAmenities(filteredAmenities));
  }, [filteredAmenities]);
  // console.log(filteredAmenities, 'filteredAmenities filteredAmenities');

  const saveClubsOrder = async (reorderedClubs) => {
    try {
      const resp = await ajax.post(
        `community/update-clubs-order`,
        {
          reorderedClubs,
        },
        {
          networkParams: { showLoader: false },
        },
      );
      // console.log('✅ Clubs have been reordered and changes were saved!', resp.data);
    } catch (err) {
      console.error('❌ Error updating club order:', err);
    }
  };

  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));

  const handleDragStart = (event) => {
    setActiveId(event.active.id);
  };

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    setActiveId(null);

    if (!over || active.id === over.id) return;

    const oldIndex = items.findIndex((item) => item?.id === active.id);
    const newIndex = items.findIndex((item) => item?.id === over.id);
    let updatedItems = arrayMove(items, oldIndex, newIndex);
    setItems(updatedItems);
    if (amenities?.length !== items?.length) {
      // Filtered view - need to update full clubs list
      updatedItems = [...sortAmenities(amenities)]; // full list

      // Find positions in full list
      const activeIndexFull = updatedItems.findIndex((item) => item?.id === active.id);
      const overIndexFull = updatedItems.findIndex((item) => item?.id === over.id);

      if (activeIndexFull !== -1 && overIndexFull !== -1) {
        updatedItems = arrayMove(updatedItems, activeIndexFull, overIndexFull);
      }
    }
    updatedItems = updatedItems.map((item, index) => ({
      ...item,
      order: index + 1,
    }));
    await saveClubsOrder(updatedItems.map(({ id, order }) => ({ id, order })));
    // set clubs to the new order
    setCommunityDetails((prev) => ({
      ...prev,
      clubs: updatedItems,
    }));
  };

  const activeAmenity = items.find((item) => item.id === activeId);

  return isAccessible && false ? (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragCancel={() => setActiveId(null)}
    >
      <SortableContext items={items?.map((item) => item?.id)} strategy={rectSortingStrategy}>
        <Grid container spacing={2} className="DragDropContainer">
          {items?.map((club) => (
            <SortableGridItem key={club?.id} id={club?.id} xs={12} sm={4}>
              <ClubBox club={club} isAccessible={isAccessible} publicView={publicView} />
            </SortableGridItem>
          ))}
        </Grid>
      </SortableContext>

      <DragOverlay adjustScale style={{ transformOrigin: '0 0' }}>
        {activeAmenity ? (
          <div style={{ cursor: 'grabbing', boxShadow: '0 4px 20px rgba(0,0,0,0.2)' }}>
            <ClubBox club={activeAmenity} isAccessible={isAccessible} publicView={publicView} />
          </div>
        ) : (
          ''
        )}
      </DragOverlay>
    </DndContext>
  ) : (
    <Grid container spacing={2}>
      {items?.map((club) => (
        <Grid item xs={12} sm={4} key={club?.id}>
          <ClubBox club={club} isAccessible={isAccessible} publicView={publicView} />
        </Grid>
      ))}
    </Grid>
  );
};

export default ClubGrid;
